import PropTypes from 'prop-types';
import { useFragment, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { payPalVaulted } from '../../actions/checkoutPaymentActions';
import { STEPS } from '../../constants/checkoutConstants';
import { trackCompletedStep } from '../../helpers/checkoutTracking';
import { useCheckoutIsLoggedIntoPayPal } from './useCheckoutIsLoggedIntoPayPal';
import { usePayPalPaymentMethod } from './usePayPalPaymentMethod';

import CheckoutCTAButton from '../../components/shared/CheckoutCTAButton';
import CheckoutContinueAction from '../../components/shared/actions/CheckoutContinueAction';
import CheckoutSavingAction from '../../components/shared/actions/CheckoutSavingAction';
import CheckoutRemovingAction from '../../components/shared/actions/CheckoutRemovingAction';

const CheckoutPayPalSubmit = ({
    buyer: buyerRef,
    isPayPalRemoving,
    isPayPalSaving,
    shippingAddressId,
    onPayPalVaulted,
    isPaymentLoading,
}) => {
    const buyer = useFragment(
        graphql`
            fragment CheckoutPayPalSubmit_buyer on User {
                ...usePayPalPaymentMethod_buyer
                ...useCheckoutIsLoggedIntoPayPal_buyer
            }
        `,
        buyerRef
    );
    const payPalAccount = usePayPalPaymentMethod({ buyer });
    const { token } = payPalAccount || {};
    const isLoggedIntoPayPal = useCheckoutIsLoggedIntoPayPal({
        buyer,
        shippingAddressId,
    });

    function onComplete(event) {
        event.preventDefault();
        trackCompletedStep(STEPS.STEP_PAYMENT);
        onPayPalVaulted(token);
    }

    let checkoutCtaButtonLabel = null;
    if (isLoggedIntoPayPal || isPayPalSaving) {
        if (!isPayPalSaving && !isPayPalRemoving) {
            checkoutCtaButtonLabel = <CheckoutContinueAction />;
        } else if (isPayPalSaving) {
            checkoutCtaButtonLabel = <CheckoutSavingAction />;
        } else {
            checkoutCtaButtonLabel = <CheckoutRemovingAction />;
        }
    }

    return isLoggedIntoPayPal || isPayPalSaving ? (
        <CheckoutCTAButton
            label={checkoutCtaButtonLabel}
            marginTop
            disabled={isPayPalSaving || isPayPalRemoving || isPaymentLoading}
            isSaving={isPayPalSaving || isPayPalRemoving}
            dataTn="paypal-save-button"
            onClick={onComplete}
        />
    ) : null;
};

CheckoutPayPalSubmit.propTypes = {
    isPayPalSaving: PropTypes.bool.isRequired,
    isPayPalRemoving: PropTypes.bool.isRequired,
    shippingAddressId: PropTypes.string.isRequired,
    onPayPalVaulted: PropTypes.func.isRequired,
    buyer: PropTypes.object.isRequired,
    isPaymentLoading: PropTypes.bool,
};

const ConnectedCheckoutPayPalSubmit = connect(
    ({ payment, transaction }) => ({
        isPayPalSaving: payment.isPayPalSaving,
        isPayPalRemoving: payment.isPayPalRemoving,
        shippingAddressId: transaction.shippingAddressId,
    }),
    {
        onPayPalVaulted: payPalVaulted,
    }
)(CheckoutPayPalSubmit);

export default ConnectedCheckoutPayPalSubmit;
